<template>
    <div>
        <div class="row">
            <div class="form-group col-12">
                <button type="button" data-toggle="modal" data-target="#modal_choose_criteria"
                        class="col-12 col-md-auto btn btn-default" @click.prevent="openModal(null)">
                    {{ $lang('Dodaj typ') }}
                </button>
            </div>

        </div>
        <div class="row" v-if="criteria.length > 0">
            <div class="col-12">
                <table class="table simple-table table-bordered table-sm">
                    <thead>
                    <tr>
                        <th scope="col" class="text-center">{{ $lang('T#') }}</th>
                        <th scope="col" class="text-center">{{ $lang('Typ') }}</th>

                        <th scope="col" class="text-center">{{ $lang('P#') }}</th>
                        <th scope="col" class="text-center">{{ $lang('Podtyp') }}</th>
                        <th scope="col" class="text-center">{{ $lang('Issue type') }}</th>
                        <th scope="col" class="text-center">{{ $lang('Priority') }}</th>
                        <th scope="col" class="text-center">{{ $lang('Opcja "Płatne"') }}</th>
                        <th scope="col" class="text-center">{{ $lang('Opcja "Wycena"') }}</th>
                        <th scope="col" class="text-center">{{ $lang('Opcja "Wolne MD"') }}</th>

                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(criterion, index) in table">
                        <td :data-title="$lang('T#')" v-if="criterion.rowspan !== null && criterion.rowspan > 0"
                            :rowspan="criterion.rowspan" class="text-center" style="vertical-align: middle;">
                            <b>{{ criterion.order }}</b>
                            <br>
                            <a v-if="criterion.order > 1" href="#" :title="$lang('Przenieś wyżej')"
                               @click.prevent="moveUp(criterion.order)">
                                <i class="fa fa-arrow-circle-up" aria-hidden="true"></i>
                            </a>
                            <a v-if="criterion.order < criterion.siblings" href="#" :title="$lang('Przenieś niżej')"
                               @click.prevent="moveDown(criterion.main_id)">
                                <i class="fa fa-arrow-circle-down" aria-hidden="true"></i>
                            </a>
                        </td>
                        <td class="criterion-main" style="text-align: center; vertical-align: middle;"
                            :data-title="$lang('Typ')"
                            v-if="criterion.rowspan !== null && criterion.rowspan > 0" :rowspan="criterion.rowspan">
                            <span class="mr-3">{{ criterion.main_name }}</span>

                            <div class="mt-1 d-md-block">
                                <a href="#" :title="$lang('Usuń')"
                                   @click.prevent="removeSubCategory(criterion.main_id)">
                                    <i class="fa fa-trash mr-1" aria-hidden="true"></i>
                                </a>
                                <a href="#" :title="$lang('Dodaj podtyp')"
                                   @click.prevent="openModal(criterion.main_id)">
                                    <i class="fa fa-plus-circle" aria-hidden="true"></i>
                                </a>
                            </div>
                        </td>
                        <td style="text-align: center; vertical-align: middle;" :data-title="$lang('P#')">
                            <template v-if="criterion.sub_id !== criterion.main_id">
                                <b>{{ criterion.sub_order }}</b>
                                <br>
                                <a v-if="criterion.sub_order > 1" href="#" :title="$lang('Przenieś wyżej')"
                                   @click.prevent="moveSubUp(criterion.main_id,criterion.sub_order)">
                                    <i class="fa fa-arrow-circle-up" aria-hidden="true"></i>
                                </a>
                                <a v-if="criterion.sub_order < criterion.sub_siblings" href="#"
                                   :title="$lang('Przenieś niżej')"
                                   @click.prevent="moveSubDown(criterion.main_id,criterion.sub_order)">
                                    <i class="fa fa-arrow-circle-down" aria-hidden="true"></i>
                                </a>
                            </template>
                        </td>
                        <td style="text-align: center; vertical-align: middle;" :data-title="$lang('Podtyp')">
                            <span v-if="criterion.sub_id !== criterion.main_id">
                                {{ criterion.sub_name }}
                                <a href="#" :title="$lang('Usuń')" class="pull-right mt-1"
                                   @click.prevent="removeSubCategory(criterion.sub_id)">
                                    <i class="fa fa-trash" aria-hidden="true"></i>
                                </a>
                            </span>
                            <span v-else>-</span>
                        </td>

                        <td :data-title="$lang('Issue type')">
                            <select
                                :class="{'select-empty-error': criterion.issueType === null || criterion.issueType === ''}"
                                class="form-control" @change="changeIssueType(criterion.sub_id, $event)">
                                <option selected v-if="criterion.issueType === null || criterion.issueType === ''"
                                        value=""></option>
                                <option :selected="criterion.issueType == type.name" v-for="type in issueTypes"
                                        :value="type.name">{{ type.name }}
                                </option>
                            </select>
                        </td>
                        <td :data-title="$lang('Priority')">
                            <select
                                :class="{'select-empty-error': criterion.priority === null || criterion.priority === ''}"
                                class="form-control" @change="changePriority(criterion.sub_id, $event)">
                                <option v-if="criterion.priority === null || criterion.priority === ''" selected
                                        value=""></option>
                                <option :selected="criterion.priority == priority.id" v-for="priority in priorities"
                                        :value="priority.id">{{ priority.name }}
                                </option>
                            </select>
                        </td>
                        <td class="text-center" style="vertical-align: middle;" :data-title="$lang('Status płatności')">
                            <input type="checkbox" :id="'payable_' + criterion.id" :name="'payable_' + criterion.id"
                                   :checked="criterion.payable"
                                   @change="changePayable(criterion.sub_id, $event)">
                            <label for="'payable_' + criterion.id">{{ $lang('Płatne') }}</label>
                        </td>
                        <td class="text-center" style="vertical-align: middle;" :data-title="$lang('Możliwa wycena')">
                            <input type="checkbox" :id="'valuable_' + criterion.id" :name="'valuable_' + criterion.id"
                                   :checked="criterion.valuable"
                                   @change="changeValuable(criterion.sub_id, $event)">
                            <label for="'valuable_' + criterion.id">{{ $lang('Wycena') }}</label>
                        </td>
                        <td class="text-center" style="vertical-align: middle;" :data-title="$lang('Wolne MD')">
                            <input type="checkbox" :id="'free_md_' + criterion.id" :name="'free_md_' + criterion.id"
                                   :checked="criterion.free_md"
                                   @change="changeFreeMd(criterion.sub_id, $event)">
                            <label for="'free_md_' + criterion.id">{{ $lang('Wolne MD') }}</label>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <div class="col-12">
                <button id="choose-criterion" @click.prevent="save" type="button" class="btn btn-primary pull-right">
                    {{ $lang('Zapisz') }}
                </button>
            </div>

        </div>
        <div class="modal fade" id="modal_choose_criteria" tabindex="-1">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ $lang('Wybór kryterium') }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group" style="margin-bottom: 0;">
                            <label for="add_criterion">{{ $lang('Kryterium') }}</label>
                            <select class="form-control" id="add_criterion" v-model="selectCriterion">
                                <option value="">{{ $lang('Wybierz kryterium') }}</option>
                                <option v-for="criterion in criteriaToChoose" :value="criterion.id">{{
                                        criterion.name
                                    }}
                                </option>
                            </select>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-default" data-dismiss="modal">{{
                                $lang('Zamknij')
                            }}
                        </button>
                        <button id="choose-criterion" @click.prevent="addCategory(addTo)" type="button"
                                class="btn btn-primary" data-dismiss="modal">
                            {{ $lang('Dodaj') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import ShowNotification from "../../mixins/show-notification";

export default {
    name: "project-criteria",
    mixins: [ShowNotification],
    props: {
        availableCriteria: {
            type: Array,
            required: true
        },
        issueTypes: {
            issueTypes: Array,
            required: true
        },
        priorities: {
            type: Array,
            required: true
        },
        settings: {
            type: Array,
            required: true
        },
        saveRoute: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            criteria: [],
            selectCriterion: null,
            addTo: null,
        }
    },
    methods: {
        criteriaByParent(id) {
            return this.criteria.filter(x => x.part_of === id);
        },
        numberOfCriteriaByParent(id) {
            return this.criteria.filter(x => x.part_of === id).length;
        },
        addCategory(parent) {
            let self = this;
            this.availableCriteria.forEach(function (item) {
                if (item.id === self.selectCriterion) {
                    self.criteria.push({
                        id: item.id,
                        name: item.name,
                        priority: null,
                        issueType: null,
                        part_of: parent,
                        order: self.getNextOrder(parent)
                    });
                }
            })
        },
        getNextOrder(parent) {
            let order = 0;
            this.criteria.filter(x => x.part_of === parent).forEach(function (object) {
                if (object.order > order) {
                    order = object.order;
                }
            });

            return order + 1;
        },
        openModal(partOf) {
            this.addTo = partOf;
            $('#modal_choose_criteria').modal('show');
        },
        changePriority(id, e) {
            this.criteria.map(function (criterion) {
                if (criterion.id === id) {
                    criterion.priority = parseInt(e.target.value);
                }
                return criterion;
            })
        },
        changeIssueType(id, e) {
            this.criteria.map(function (criterion) {
                if (criterion.id === id) {
                    criterion.issueType = e.target.value;
                }
                return criterion;
            })
        },
        changePayable(id, e) {
            this.criteria.map(function (criterion) {
                if (criterion.id === id) {
                    criterion.payable = e.target.value;
                }
                return criterion;
            })
        },
        changeValuable(id, e) {
            this.criteria.map(function (criterion) {
                if (criterion.id === id) {
                    criterion.valuable = e.target.value;
                }
                return criterion;
            })
        },
        changeFreeMd(id, e) {
            this.criteria.map(function (criterion) {
                if (criterion.id === id) {
                    criterion.free_md = e.target.value;
                }
                return criterion;
            })
        },
        removeSubCategory(id) {
            let removed = this.criteria.filter(x => x.id === id)[0];
            this.criteria = this.criteria.filter(x => x.id !== id);
            this.criteria = this.criteria.map(function (item) {
                if (item.part_of === removed.part_of && item.order > removed.order) {
                    item.order = item.order - 1;
                }

                return item;
            });
        },
        save() {
            let self = this;
            this.validation();
            axios.post(this.saveRoute, {criteria: this.criteria})
                 .then(function (response) {
                     self.showNotification('success', self.$lang('Zapisano!'));
                 })
                 .catch(function (error) {
                     self.showNotification('error', self.$lang('Błąd zapisu!'))
                     console.log(error)
                 });

        },
        validation() {

        },

        moveUp(order) {
            let current = this.table.filter(x => x.order === order)[0];
            let previous = this.table.filter(x => x.order === order - 1)[0];

            this.changeOrder(current.main_id, current.order - 1);
            this.changeOrder(previous.main_id, previous.order + 1);

        },
        moveDown(order) {
            let current = this.table.filter(x => x.order === order);
            let next = this.table.filter(x => x.order === order - 1);

            this.changeOrder(current.main_id, current.order + 1);
            this.changeOrder(next.main_id, next.order - 1);
        },
        moveSubUp(main_id, order) {
            let current = this.table.filter(x => x.sub_order === order && x.main_id === main_id)[0];
            let previous = this.table.filter(x => x.sub_order === order - 1 & x.main_id === main_id)[0];

            this.changeOrder(current.sub_id, current.sub_order - 1);
            this.changeOrder(previous.sub_id, previous.sub_order + 1);
        },
        moveSubDown(main_id, order) {
            let current = this.table.filter(x => x.sub_order === order && x.main_id === main_id)[0];
            let next = this.table.filter(x => x.sub_order === order + 1 && x.main_id === main_id)[0];

            this.changeOrder(current.sub_id, current.sub_order + 1);
            this.changeOrder(next.sub_id, next.sub_order - 1);
        },
        changeOrder(id, newVal) {
            this.criteria.map(function (criterion) {
                if (criterion.id === id) {
                    criterion.order = newVal;
                }
                return criterion;
            });
        },

    },
    computed: {
        table() {
            let mainElements = this.criteriaByParent(null).length;
            let bag = [], self = this;
            this.criteriaByParent(null).forEach(function (criterionMain) {
                let rowspan = self.numberOfCriteriaByParent(criterionMain.id);
                if (rowspan > 0) {
                    self.criteriaByParent(criterionMain.id).forEach(function (subCriterion, index) {

                        bag.push({
                            main_id: criterionMain.id,
                            main_name: criterionMain.name,
                            sub_id: subCriterion.id,
                            sub_name: subCriterion.name,
                            rowspan: subCriterion.order === 1 ? rowspan : null,
                            priority: subCriterion.priority,
                            issueType: subCriterion.issueType,
                            payable: subCriterion.payable,
                            valuable: subCriterion.valuable,
                            free_md: subCriterion.free_md,
                            order: criterionMain.order,
                            sub_order: subCriterion.order,
                            siblings: mainElements,
                            sub_siblings: rowspan
                        });
                    });
                } else {

                    bag.push({
                        main_id: criterionMain.id,
                        main_name: criterionMain.name,
                        priority: criterionMain.priority,
                        issueType: criterionMain.issueType,
                        sub_id: criterionMain.id,
                        sub_name: criterionMain.name,
                        payable: criterionMain.payable,
                        valuable: criterionMain.valuable,
                        free_md: criterionMain.free_md,
                        rowspan: 1,
                        order: criterionMain.order,
                        sub_order: criterionMain.order,
                        siblings: mainElements,
                        sub_siblings: 1
                    });
                }
            });

            function sorter(a, b) {
                if (a.order === b.order) {
                    return a.sub_order < b.sub_order ? -1 : 1
                } else {
                    return a.order < b.order ? -1 : 1
                }
            }

            bag.sort(sorter);

            return bag;
        },
        criteriaToChoose() {
            let self = this;

            return this.availableCriteria.filter(function (item) {
                return self.criteria.filter(function (ii) {
                    return ii.id === item.id;
                }).length === 0;
            });
        }
    },
    created() {
        this.criteria = this.settings;
    }
}
</script>
<style>
.select-empty-error {
    border: dashed 2px red !important;
}

.criterion-main, .criterion-main a {
    background-color: var(--primary-to-yellow);
    color: #fff;
}

</style>
